import { useEffect, useState } from "react";

function InstallButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);

  useEffect(() => {
    // Detect if running on Android or Windows
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = userAgent.includes("android");
    const isWindows = userAgent.includes("windows");

    // Detect if already installed as a PWA
    const isInStandaloneMode =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    // Listen for beforeinstallprompt
    const handler = (e) => {
      if ((isAndroid || isWindows) && !isInStandaloneMode) {
        e.preventDefault(); // Prevent default Chrome install prompt
        setDeferredPrompt(e); // Save event for later
        setShowInstallButton(true); // Show custom button
      }
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt(); // Show native install prompt
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User response: ${outcome}`);

    setDeferredPrompt(null);
    setShowInstallButton(false);
  };

  if (!showInstallButton) return null;

   return (
  <button
    onClick={handleInstallClick}
    className="fixed top-4 right-4 flex items-center bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-3 rounded-full shadow-lg transition duration-200 z-50"
  >
    <img
      src="/logo512.png"
      alt="InsightOS Logo"
      className="w-6 h-6 mr-2 rounded-full"
    />
    Install Web App
  </button>
);
}



export default InstallButton;
